import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  id: "topnav"
};
const _hoisted_2 = {
  class: "left-area"
};
const _hoisted_3 = {
  class: "rl-flex-wrap"
};
const _hoisted_4 = {
  key: 0,
  id: "top-nav-banner"
};
const _hoisted_5 = ["target", "href"];
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = ["href"];
const _hoisted_9 = ["href"];
const _hoisted_10 = ["href"];
const _hoisted_11 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_submenu = _resolveComponent("el-submenu");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_menu = _resolveComponent("el-menu");
  const _directive_intersectionObserver = _resolveDirective("intersectionObserver");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("button", {
    class: "switch-button",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.clickSwitchButton && $setup.clickSwitchButton(...args))
  }, _cache[7] || (_cache[7] = [_createElementVNode("i", {
    class: "fa fa-bars",
    "aria-hidden": "true"
  }, null, -1)])), _createVNode(_component_router_link, {
    class: "logo",
    to: {
      path: $setup.getLanguagePath()
    },
    onClick: _cache[1] || (_cache[1] = $event => $setup.gaTrackButtonClick('top-nav-courses-logo'))
  }, {
    default: _withCtx(() => _cache[8] || (_cache[8] = [_createElementVNode("svg", {
      viewBox: "0 0 290.5 22.6"
    }, [_createElementVNode("use", {
      "xlink:href": "#rl-course-logo"
    })], -1)])),
    _: 1
  }, 8, ["to"])]), _createElementVNode("section", _hoisted_3, [$setup.campaignBanner ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_withDirectives((_openBlock(), _createElementBlock("a", {
    target: $setup.campaignBanner.Blank ? '_blank' : '_self',
    style: {
      "text-decoration": "none"
    },
    href: $setup.campaignBanner.Url,
    onClick: _cache[2] || (_cache[2] = $event => $setup.gaTrackEvent('banner-clicks', 'nav-banner', $setup.getEventLabel($setup.campaignBanner.EventLabel)))
  }, [_createElementVNode("img", {
    style: {
      "max-width": "100%",
      "height": "100%"
    },
    src: $setup.campaignBanner.BannerUrl + $setup.campaignBanner.ImageFileName
  }, null, 8, _hoisted_6)], 8, _hoisted_5)), [[_directive_intersectionObserver, $setup.gaTrackEvent('banner-impression', 'nav-banner', $setup.getEventLabel($setup.campaignBanner.EventLabel), 1)]])])) : _createCommentVNode("", true), $setup.member.states.loginInfo?.data.login !== undefined ? (_openBlock(), _createBlock(_component_el_menu, {
    key: 1,
    ref: "elMenu",
    class: "right-area",
    mode: "horizontal",
    "active-text-color": "false",
    "menu-trigger": $setup.hasTouchScreen ? 'click' : 'hover',
    router: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_el_submenu, {
      ref: "multiLangSwitcher",
      index: "1",
      "popper-append-to-body": false
    }, {
      title: _withCtx(() => _cache[9] || (_cache[9] = [_createElementVNode("svg", {
        viewBox: "0 1 34 34"
      }, [_createElementVNode("use", {
        "xlink:href": "#language"
      })], -1)])),
      default: _withCtx(() => [_createVNode(_component_el_menu_item, {
        index: $setup.getTargetLanguagePath($setup.languageEnum.EN)
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("English ")])),
        _: 1
      }, 8, ["index"]), _createVNode(_component_el_menu_item, {
        index: $setup.getTargetLanguagePath($setup.languageEnum.DE)
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("Deutsch ")])),
        _: 1
      }, 8, ["index"]), _createVNode(_component_el_menu_item, {
        index: $setup.getTargetLanguagePath($setup.languageEnum.JP)
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("日本語 ")])),
        _: 1
      }, 8, ["index"]), _createVNode(_component_el_menu_item, {
        index: $setup.getTargetLanguagePath($setup.languageEnum.TW)
      }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("繁體中文")])),
        _: 1
      }, 8, ["index"]), _createVNode(_component_el_menu_item, {
        index: $setup.getTargetLanguagePath($setup.languageEnum.CN)
      }, {
        default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("简体中文")])),
        _: 1
      }, 8, ["index"])]),
      _: 1
    }, 512), $setup.member.states.loginInfo?.data.login ? (_openBlock(), _createBlock(_component_el_submenu, {
      key: 0,
      ref: "loggedInMemberMenu",
      index: "2",
      class: "avatar",
      "popper-append-to-body": false
    }, {
      title: _withCtx(() => [_createElementVNode("img", {
        src: $setup.member.states.loginInfo.data.avatarUrl || $setup.member.states.loginInfo.data.defaultAvatarUrl
      }, null, 8, _hoisted_7)]),
      default: _withCtx(() => [_createVNode(_component_el_menu_item, {
        index: $setup.getLanguagePath() + 'bookmark'
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("TOP_NAV.BOOKMARK")), 1)]),
        _: 1
      }, 8, ["index"]), _createVNode(_component_el_menu_item, {
        index: $setup.getLanguagePath() + 'history'
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("TOP_NAV.HISTORY")), 1)]),
        _: 1
      }, 8, ["index"]), _createVNode(_component_el_menu_item, {
        index: null,
        onClick: $setup.logout
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("TOP_NAV.LOG_OUT")), 1)]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    }, 512)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createVNode(_component_el_menu_item, {
      class: "rl-uppercase rl-hidden-mobile"
    }, {
      default: _withCtx(() => [_createElementVNode("a", {
        href: $setup.loginUrl,
        onClick: _cache[3] || (_cache[3] = $event => $setup.gaTrackButtonClick('top-nav-login'))
      }, _toDisplayString(_ctx.$t("TOP_NAV.LOG_IN")), 9, _hoisted_8)]),
      _: 1
    }), _createVNode(_component_el_menu_item, {
      class: "rl-hidden-mobile"
    }, {
      default: _withCtx(() => [_createElementVNode("a", {
        href: $setup.signupUrl
      }, [_createVNode(_component_el_button, {
        type: "primary",
        class: "rl-uppercase",
        onClick: _cache[4] || (_cache[4] = $event => $setup.gaTrackButtonClick('top-nav-signup'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("TOP_NAV.SIGN_UP")), 1)]),
        _: 1
      })], 8, _hoisted_9)]),
      _: 1
    }), _createVNode(_component_el_submenu, {
      ref: "memberMenu",
      index: "3",
      class: "rl-hidden-desktop",
      "popper-append-to-body": false
    }, {
      title: _withCtx(() => _cache[15] || (_cache[15] = [_createElementVNode("svg", {
        viewBox: "0 0 34 34"
      }, [_createElementVNode("use", {
        "xlink:href": "#account_1_"
      })], -1)])),
      default: _withCtx(() => [_createElementVNode("a", {
        href: $setup.loginUrl,
        onClick: _cache[5] || (_cache[5] = $event => $setup.gaTrackButtonClick('top-nav-login'))
      }, [_createVNode(_component_el_menu_item, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("TOP_NAV.LOG_IN")), 1)]),
        _: 1
      })], 8, _hoisted_10), _createElementVNode("a", {
        href: $setup.signupUrl,
        onClick: _cache[6] || (_cache[6] = $event => $setup.gaTrackButtonClick('top-nav-signup'))
      }, [_createVNode(_component_el_menu_item, null, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("TOP_NAV.SIGN_UP")), 1)]),
        _: 1
      })], 8, _hoisted_11)]),
      _: 1
    }, 512)], 64))]),
    _: 1
  }, 8, ["menu-trigger"])) : _createCommentVNode("", true)])]);
}